import toNumber from 'lodash/toNumber'

export function numberToShortForm (num, precision = 1, label) {
  let formatted = Math.abs(parseInt(num))
  const digits = formatted.toString().length

  if (digits > 3) {
    formatted = formatted / Math.pow(10, 3)
    if (formatted !== parseInt(formatted)) {
      if (label === 'D_LDPNT_2'){
         formatted = formatted.toFixed(2)
       }else{
         formatted = formatted.toFixed(precision)
       }
     
    }
    formatted = `${formatted}k`
  } else if (formatted !== num) {
    if (label === 'D_LDPNT_2'){
      formatted = Math.abs(num.toFixed(2))
    }else{
      formatted = Math.abs(num.toFixed(precision))
    }
    
  }
  return num >= 0 ? formatted : `-${formatted}`
}

export function formatNumber (numStr, prefix = '') {
  numStr = typeof numStr === 'string' ? numStr : numStr.toString()
  let num = numStr
  const hasK = numStr.indexOf('k') >= 0
  const isNegative = numStr.indexOf('-') >= 0
  if (typeof numStr === 'string') {
    num = Math.abs(toNumber(numStr.replace('k', '')))
  }
  const numInt = parseInt(num)
  const digitString = num.toString()
  let lengthAfterDecimal = 0

  if (digitString.indexOf('.') !== -1) {
    lengthAfterDecimal = digitString.split('.')[1].length
  }

  const afterDecimalNum = (num - numInt).toFixed(lengthAfterDecimal)
  const afterDecimalStr = afterDecimalNum.toString().replace('0.', '')
  const beforeDecimal = numInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  const suffix = hasK ? 'k' : ''
  prefix = isNegative ? `-${prefix}` : prefix
  return afterDecimalNum > 0 ? `${prefix}${beforeDecimal}.${afterDecimalStr}${suffix}` : `${prefix}${beforeDecimal}${suffix}`
}

export function numberToDollar (num) {
  return `${formatNumber(num, '$')}`
}

export function getTickInterval(min, max, numBuckets, roundTo=1000) {
  const interval =  (max - min)/numBuckets
  return Math.ceil(interval/roundTo)*roundTo
}

export const occupationBubbleChartData = {
  "Arizona": { year: 2024, fips: 4, "childAdultMin": 48677, "childAdultMax": 84200 },
  "Apache": { year: 2024, fips: 4001, "childAdultMin": 42158, "childAdultMax": 76996 },
  "Cochise": { year: 2024, fips: 4003, "childAdultMin": 40726, "childAdultMax": 70423 },
  "Coconino": { year: 2024, fips: 4005, "childAdultMin": 52943, "childAdultMax": 89193 },
  "Gila": { year: 2024, fips: 4007, "childAdultMin": 42672, "childAdultMax": 76113 },
  "Graham": { year: 2024, fips: 4009, "childAdultMin": 44492, "childAdultMax": 73511 },
  "Greenlee": { year: 2024, fips: 4011, "childAdultMin": 43624, "childAdultMax": 74751 },
  "La Paz": { year: 2024, fips: 4012, "childAdultMin": 40790, "childAdultMax": 74148 },
  "Maricopa": { year: 2024, fips: 4013, "childAdultMin": 51380, "childAdultMax": 87919 },
  "Mohave": { year: 2024, fips: 4015, "childAdultMin": 41902, "childAdultMax": 74491 },
  "Navajo": { year: 2024, fips: 4017, "childAdultMin": 43192, "childAdultMax": 77802 },
  "Pima": { year: 2024, fips: 4019, "childAdultMin": 41849, "childAdultMax": 76507 },
  "Pinal": { year: 2024, fips: 4021, "childAdultMin": 51116, "childAdultMax": 84364 },
  "Santa Cruz": { year: 2024, fips: 4023, "childAdultMin": 39444, "childAdultMax": 68439 },
  "Yavapai": { year: 2024, fips: 4025, "childAdultMin": 44402, "childAdultMax": 80901 },
  "Yuma": { year: 2024, fips: 4027, "childAdultMin": 43161, "childAdultMax": 75251 }
};
